export default {
  'startProcessInstance.startMappings': 'Start mappings',
  'startProcessInstance.responseMappings': 'Response mappings',
  'startProcessInstance.mapping': 'Mapping',
  'startProcessInstance.addMapping': 'Add mapping',
};
